/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FuelLevel;
(function (FuelLevel) {
    FuelLevel["Reserve"] = "Reserve";
    FuelLevel["OneEight"] = "OneEight";
    FuelLevel["TwoEight"] = "TwoEight";
    FuelLevel["ThreeEight"] = "ThreeEight";
    FuelLevel["FourEight"] = "FourEight";
    FuelLevel["FiveEight"] = "FiveEight";
    FuelLevel["SixEight"] = "SixEight";
    FuelLevel["SevenEight"] = "SevenEight";
    FuelLevel["Full"] = "Full";
})(FuelLevel || (FuelLevel = {}));
export function FuelLevelFromJSON(json) {
    return FuelLevelFromJSONTyped(json, false);
}
export function FuelLevelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FuelLevelToJSON(value) {
    return value;
}
